import { Button, Title, Text } from '@mantine/core';
import { useHistory } from 'react-router-dom';
import classes from './PageNotFound.module.css';

const PageNotFound = () => {
  const history = useHistory();

  return (
    <div className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>¡Oops! Página no encontrada</Title>
      <Text className={classes.description}>
        La página que buscas no existe. Quizá la dirección esté mal escrita o la página haya sido movida.
      </Text>
      <Button onClick={() => history.push('/')} variant="white" size="md">
        Volver al inicio
      </Button>
    </div>
  );
};

export default PageNotFound;
